import _ from "lodash";
import * as React from "react";
import * as Comp from "../../../../components";
import * as Forms from "../../../../forms";
import * as M from "../../../../models";
import { ReactHelper } from "../../../../utils";
import { TinymceOptions } from "../../../../options";

interface OwnProps {
    formComponent: Comp.Validation.IComponentWithValidatedForm;
}

interface OwnState {
}

export class PlacementEditor extends React.Component<OwnProps, OwnState> {

    private _fieldname = "placements";
    private _placements: M.Editors.SelectItem[] = _.orderBy(M.Abstract.Placements.Values, "name").map((x) => ({
        id: x.id,
        render: x.name,
    }));

    public constructor(props: any) {
        super(props);
        this.state = {
        };
    }

    public render() {
        const label = this.props.formComponent.getFieldLabel(this._fieldname);
        const formModel = this.props.formComponent.getFormModelData<Forms.AdminAbstract.AbstractTypeData>();
        const visible = formModel.placements.filter((x) => !x.isDeleted).length;

        const placements = formModel.placements
            .map((x, i) => {
                const placement = _.find(this._placements, (p) => p.id === x.placementId);
                const placementName = placement ? (placement.render + " ") : "";
                return <li key={i} className="list-builder-item" style={{ display: x.isDeleted ? "none" : "block" }}>
                    <div className="list-builder-fields">
                        <Comp.Editors.DropdownField
                            formComponent={this.props.formComponent}
                            name={`${this._fieldname}[${i}].placementId`}
                            items={this._placements}
                            placeholder="Select placement..."
                        />

                        <Comp.Editors.NumberField
                            formComponent={this.props.formComponent}
                            labelHint="In minutes"
                            name={`${this._fieldname}[${i}].sessionDuration`}
                        />

                        <Comp.Editors.TextField
                            formComponent={this.props.formComponent}
                            hint={`Overerides the default placement and type display in emails (${placementName}${formModel.shortName})`}
                            name={`${this._fieldname}[${i}].displayName`}
                        />

                        <Comp.Editors.RichTextField
                            formComponent={this.props.formComponent}
                            name={`${this._fieldname}[${i}].invitationEmailText`}
                            options={TinymceOptions.minimumEdit()}
                        />

                        <Comp.Editors.RichTextField
                            formComponent={this.props.formComponent}
                            name={`${this._fieldname}[${i}].confirmationEmailText`}
                            options={TinymceOptions.minimumEdit()}
                        />
                    </div>
                    <a className="req remove-trigger" href="#" onClick={(e) => { ReactHelper.emptyClick(e); this.onDelete(x.index); }} title="Remove placement">
                        <i className="fa fa-times"></i>
                    </a>
                </li>;
            });

        return <div>
            <Comp.Editors.FormField label={label} name={this._fieldname}>
                <ul className="list-builder" style={{ display: visible ? "block" : "none" }}>
                    {placements}
                </ul>

                <a href="#" onClick={(e) => { ReactHelper.emptyClick(e); this.onAdd(); }}>
                    <i className="fa fa-plus"></i> Add placement
                </a>
            </Comp.Editors.FormField>
        </div>;
    }

    private onAdd() {
        const formModel = this.props.formComponent.getFormModelData<Forms.AdminAbstract.AbstractTypeData>();
        const defItem = { ...Forms.AdminAbstract.DefaultAbstractTypePlacement };

        formModel.placements.push({
            ...defItem,
            index: formModel.placements.length,
            isNew: true,
        });

        this.props.formComponent.updateFormModelData(formModel);
    }

    private onDelete(idx: number) {
        const formModel = this.props.formComponent.getFormModelData<Forms.AdminAbstract.AbstractTypeData>();
        const item = _.find(formModel.placements, (x, i) => x.index === idx);

        if (item) {
            item.isDeleted = true;
            this.props.formComponent.updateFormModelData(formModel);
        }
    }
}



// WEBPACK FOOTER //
// ./src/containers/adminAbstracts/editType/components/PlacementEditor.tsx